// TODO: make it fancy
// TODO: UNDER CONSTRUCTION

// const gsap = require('gsap')
// typical import
// const gsap = require('gsap/gsap-core')
// const MotionPathPlugin = require('gsap/MotionPathPlugin')

// get other plugins:
// import ScrollTrigger from "gsap/ScrollTrigger";
// import Flip from "gsap/Flip";
// import Draggable from "gsap/Draggable";
// import MotionPathPlugin from "gsap/MotionPathPlugin";


// or all tools are exported from the "all" file (excluding members-only plugins):
// import { gsap, ScrollTrigger, Draggable, MotionPathPlugin } from "gsap/all";

// don't forget to register plugins
// gsap.registerPlugin(MotionPathPlugin);

module.exports = {
    extends: [
        '/',
        'base',
        'statusController',
        'statusController',
    ],

    hooks: {
        // _attach($element, options){
        //     const $svg = $('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="40" viewBox="0 0 60 40"><polygon id="motionPath" points="5 8 13.497 30.876 17.418 30.876 21.768 19.111 23.363 20.418 33.418 20.418 33.451 26.22 21.667 26.301 21.667 30.876 37.209 30.901 37.374 15.901 24.484 15.571 24.549 12.604 37.242 12.604 37.353 8 21.667 8 15.549 22.297 9.248 8 5 8" style="fill:none;stroke:#000;stroke-miterlimit:10"/></svg>')
        //     const $dot = $('<div class="dot"></div>')
        //     const $animation = $element.find('.animation')
        //     $animation.html($svg)
        //     $animation.append($dot)
        //     DrawSVGPlugin.to($dot, {
        //         motionPath: '#motionPath',
        //         align: '#motionPath',
        //         duration: 3,
        //         repeat: 10,
        //         repeatDelay: 1,
        //         ease: 'none'
        //     })
        // }
    }
}